import React from "react";
import { Routes, Route } from "react-router-dom";
import { Calculadoras, Variacao, Curva } from "../../../pagesPublic";

const CalculadorasRoutes = () => {
  return (
    <Routes>
      <Route path={"/curva"} element={<Curva />} />
      <Route path={"/variacao"} element={<Variacao />} />
      <Route path={"*"} element={<Calculadoras />} />
    </Routes>
  );
};

export default CalculadorasRoutes;
